// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"42500cbe","394":"b5fc430a","635":"24f8a2a4","805":"2672fa6c","898":"f9414496"}[chunkId] + ".chunk.js";
};